import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">精彩预告</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            热门影片预告片、幕后特辑与导演访谈，精彩内容一网打尽
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-[180px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-accent-500/80 flex items-center justify-center group-hover:bg-accent-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-background-950/70 text-foreground-200 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-400">{item.views} 次观看</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}